/**
 * v2.2 P1.2: what a failed request says in a toast.
 *
 * Over HTTP/2 `res.statusText` is empty, so the old toast read "500 " — and Sam reported a server
 * error as "bad gateway". The words now come from the status, never from the transport, and a 5xx
 * carries the `X-Error-Id` the API stamped on it (P1.3) so the ref can be looked up on /system.
 */
export function describeHttpError(
  status: number,
  detail: string | null | undefined,
  errorId: string | null | undefined,
): string {
  const server = detail && detail.trim() ? detail.trim() : null;
  switch (status) {
    case 400:
      return server ? `Bad request — ${server}` : "Bad request";
    case 401:
      return "Signed out — sign in again";
    case 403:
      return server ? `Not allowed — ${server}` : "Not allowed";
    case 404:
      return server ? `Not found — ${server}` : "Not found";
    case 409:
      return server ? `Conflict — ${server}` : "Conflict";
    case 422:
      return server ? `Check the form — ${server}` : "Check the form";
    case 429:
      return "Slow down — too many requests, try again in a minute";
    case 502:
    case 503:
    case 504:
      return "Server unreachable — retry";
    default:
      if (status >= 500) return errorId ? `Server error · ref ${shortRef(errorId)}` : "Server error";
      return server ?? `Request failed (${status})`;
  }
}

/** The first 8 characters are what a person reads aloud; /system's search matches on the prefix. */
export function shortRef(errorId: string): string {
  return errorId.slice(0, 8);
}
